import { useSelector } from "react-redux"

import { isExternalDemoMode } from "../Utils/externalDemoMode"

export const useExternalDemoMode = () => useSelector((state) => isExternalDemoMode(state?.auth))
